import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { Icon } from '../index';
import ReactDOM from 'react-dom';
import { tuple } from '../_utils/type';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { usePrevious } from '../_utils/hooks';
import devWarning from '../_utils/devwarning';
export var AlertTypes = tuple('success', 'info', 'warning', 'error');
var IconTypes = tuple('right-solid', 'notice', 'warning-solid', 'warning-solid');
export var allBannerAlertPortals = new _Map();
var allBannerAlertPortalsContainer = document.querySelector('body');

var setContainerStyle = function setContainerStyle(dom, posInfo) {
  var styles = {
    left: posInfo[0] + 'px',
    top: posInfo[1] + 'px'
  };

  _Object$keys(styles).forEach(function (prop) {
    dom.style.setProperty(prop, styles[prop]);
  });
};
/**
 * @description 创建悬浮顶部的反馈浮层容器
 * @param alertContainer 反馈浮层容器ref
 * @param alertPrefixCls 反馈浮层前缀class
 * @param bannerOffset 反馈浮层悬浮顶部的坐标量
 *
 */


function createAlertContainer(alertContainer, alertPrefixCls, bannerOffset) {
  var posKey = bannerOffset.join(',');
  var container = document.createElement('div');
  container.classList.add("".concat(alertPrefixCls, "-banner-container")); // container.classList.add(`${alertPrefixCls}-banner-container-flex`)

  setContainerStyle(container, bannerOffset);
  alertContainer.current = container;
  allBannerAlertPortalsContainer.appendChild(container);
  allBannerAlertPortals.set(posKey, container);
}

var Alert = function Alert(props) {
  var _classNames, _classNames2;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var alertProps = getCompProps('Alert', userDefaultProps, props); // 属性需要合并一遍用户定义的默认属性

  var type = alertProps.type,
      message = alertProps.message,
      showIcon = alertProps.showIcon,
      icon = alertProps.icon,
      className = alertProps.className,
      customPrefixcls = alertProps.prefixCls,
      closable = alertProps.closable,
      closeNode = alertProps.closeNode,
      delayOffTime = alertProps.delayOffTime,
      onClose = alertProps.onClose,
      extra = alertProps.extra,
      banner = alertProps.banner,
      bannerOffset = alertProps.bannerOffset;
  devWarning(AlertTypes.indexOf(type) === -1, 'alert', "cannot found alert type '".concat(type, "'"));

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var previousBannerOffset = usePrevious(bannerOffset);
  var timerRef = useRef();
  var alertRef = useRef(null);
  var alertContainer = useRef(allBannerAlertPortalsContainer);
  var forceUpdate = useState(0)[1];
  var previousMessage = usePrevious(message);
  var alertPrefixCls = getPrefixCls(prefixCls, 'alert', customPrefixcls);
  useEffect(function () {
    if (banner) {
      var previousPosKey = previousBannerOffset.join(',');
      var posKey = bannerOffset.join(',');

      if (previousPosKey !== posKey || !alertContainer.current || alertContainer.current === allBannerAlertPortalsContainer) {
        var oldContainer = allBannerAlertPortals.get(previousPosKey);
        setTimeout(function () {
          var _a;

          if (((_a = oldContainer === null || oldContainer === void 0 ? void 0 : oldContainer.children) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            var _context;

            _includesInstanceProperty(_context = _Array$from(allBannerAlertPortalsContainer.children)).call(_context, oldContainer) && allBannerAlertPortalsContainer.removeChild(oldContainer);
            allBannerAlertPortals.delete(previousPosKey);
          }
        }, 0);
        var newContainer = allBannerAlertPortals.get(posKey);

        if (newContainer) {
          alertContainer.current = newContainer;
        } else {
          createAlertContainer(alertContainer, alertPrefixCls, bannerOffset);
        }
      }

      forceUpdate(function (val) {
        return val + 1;
      });
    }
  }, [banner, bannerOffset, previousBannerOffset, forceUpdate, alertPrefixCls]);

  var showAlert = function showAlert() {
    setVisible(true);
  };

  var hideAlert = useCallback(function () {
    timerRef.current = window.setTimeout(function () {
      setVisible(false);
    }, delayOffTime);
  }, [delayOffTime]);
  useEffect(function () {
    if (delayOffTime === 0 || message !== previousMessage) {
      showAlert();
      clearTimer();
    }

    if (delayOffTime === 0) {
      return function () {
        clearTimeout(timerRef.current);
      };
    }

    hideAlert();
    return function () {
      clearTimeout(timerRef.current);
    };
  }, [delayOffTime, message, previousMessage, timerRef, hideAlert]);
  var alertClasses = classNames(alertPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(alertPrefixCls, "-closable"), closable), _defineProperty(_classNames, "".concat(alertPrefixCls, "-banner"), banner), _defineProperty(_classNames, "".concat(alertPrefixCls, "-leave"), !visible || !message), _defineProperty(_classNames, "".concat(alertPrefixCls, "-visible"), visible && message), _defineProperty(_classNames, "".concat(alertPrefixCls, "-container"), true), _classNames));

  var handleClose = function handleClose() {
    onClose && onClose();
    setVisible(false);
    clearTimer();
  };

  function clearTimer() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  }

  function handleMouseOut() {
    hideAlert();
  }

  var events = {};

  if (delayOffTime) {
    events.onMouseOver = clearTimer;
    events.onMouseOut = handleMouseOut;
  }

  var alertIconType = IconTypes[AlertTypes.indexOf(type)];

  var getAlertColorType = function getAlertColorType(mode) {
    var _context2;

    return _concatInstanceProperty(_context2 = "alert-".concat(type, "-")).call(_context2, mode, "-color");
  };

  var iconNode = /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(alertPrefixCls, "-icon"), getAlertColorType('icon'))
  }, icon || /*#__PURE__*/React.createElement(Icon, {
    type: alertIconType
  }));
  var AlertComp = /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(alertClasses, getAlertColorType('bg'), getAlertColorType('border'))
  }, events, {
    ref: alertRef
  }), showIcon && iconNode, /*#__PURE__*/React.createElement("div", {
    className: classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(alertPrefixCls, "-message"), true), _defineProperty(_classNames2, "".concat(alertPrefixCls, "-without-icon-message"), !showIcon), _classNames2))
  }, message), extra, closable && type !== 'success' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(alertPrefixCls, "-close-icon"),
    onClick: handleClose
  }, closeNode || /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })));

  if (banner) {
    return /*#__PURE__*/ReactDOM.createPortal(AlertComp, alertContainer.current);
  } else {
    return AlertComp;
  }
};

Alert.displayName = 'Alert';
export default Alert;